import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-header-card',
  templateUrl: './dashboard-header-card.component.html',
  styleUrls: ['./dashboard-header-card.component.scss']
})
export class DashboardHeaderCardComponent implements OnInit {

  @Input() title;

  constructor() { }

  ngOnInit() {
  }

}
